export const URL = 'https://ssce-dev-cl01.ssnc-corp.cloud/analytics/';